
  import React from 'react'
  import { MDXTag } from '@mdx-js/tag'
  import { Playground } from 'docz';

const layoutProps = {
  
};
export default class MDXContent extends React.Component {
  constructor(props) {
    super(props)
    this.layout = null
  }
  render() {
    const { components, ...props } = this.props

    return <MDXTag
             name="wrapper"
             
             components={components}>
<MDXTag name="h1" components={components} props={{"id":"시작하기"}}>{`시작하기`}</MDXTag>
<MDXTag name="p" components={components}>{`이 웹사이트는 데브시스터즈 웹사이트에 사용되는 재사용 가능한 리액트 컴포넌트들을 모아놓은 문서입니다.`}</MDXTag>
<MDXTag name="p" components={components}>{`리액트 컴포넌트들은 여러 패키지로 나뉘어 배포되어있는데, 묶어서 `}<MDXTag name="inlineCode" components={components} parentName="p">{`@devsisters/ui-*`}</MDXTag>{`라고 부르겠습니다.`}</MDXTag>
<MDXTag name="blockquote" components={components}>
<MDXTag name="p" components={components} parentName="blockquote">{`참고: `}<MDXTag name="inlineCode" components={components} parentName="p">{`@devsisters/ui-*`}</MDXTag>{`는 데브시스터즈 사내에서만 사용할 수 있는 라이브러리입니다.`}</MDXTag>
<MDXTag name="p" components={components} parentName="blockquote">{`사설 패키지 레지스트리를 이용하여 관리중이므로 회사 외부에서 설치할 수 없습니다.`}</MDXTag>
<MDXTag name="p" components={components} parentName="blockquote">{`라이브러리의 외부 공개 및 오픈소스화를 고려하고는 있으나 회사 사정에 따라 실행하지 않을 수 있습니다.`}</MDXTag>
</MDXTag>
<MDXTag name="h2" components={components} props={{"id":"프로젝트-요구사항"}}>{`프로젝트 요구사항`}</MDXTag>
<MDXTag name="p" components={components}><MDXTag name="inlineCode" components={components} parentName="p">{`@devsisters/ui-*`}</MDXTag>{`를 사용하기 위해 미리 구성해야 하는 설정(웹팩 등)이 있습니다.`}</MDXTag>
<MDXTag name="p" components={components}><MDXTag name="a" components={components} parentName="p" props={{"href":"./requirements"}}>{`프로젝트 요구사항`}</MDXTag>{` 문서를 참고하세요.`}</MDXTag>
<MDXTag name="h2" components={components} props={{"id":"이-문서에-대해"}}>{`이 문서에 대해...`}</MDXTag>
<MDXTag name="p" components={components}>{`왼쪽의 메뉴에서 컴포넌트별로 정리된 문서를 찾아 읽으시면 됩니다.`}</MDXTag>
<MDXTag name="p" components={components}>{`이 문서는 `}<MDXTag name="a" components={components} parentName="p" props={{"href":"https://www.docz.site"}}>{`docz`}</MDXTag>{`를 사용하여 작성되었습니다.
docz는 손쉽게 인터렉티브한 리액트 컴포넌트 문서를 작성할 수 있도록 도와주는 도구입니다.`}</MDXTag>
<MDXTag name="h3" components={components} props={{"id":"놀이터"}}>{`놀이터`}</MDXTag>
<MDXTag name="p" components={components}>{`놀이터에 작성되어있는 코드를 고치면 프로덕션에서 어떻게 적용되는지 실시간으로 확인해볼 수 있습니다.`}</MDXTag>
<Playground __position={0} __code={'<p>여기에 써있는 내용을 고쳐보세요</p>'} __scope={{props: this ? this.props : props,}}>
  <p>여기에 써있는 내용을 고쳐보세요</p>
</Playground>
           </MDXTag>
  }
}
  